import React, { Component, PropTypes } from 'react';
import { SparkToolbar } from '../ui/spark';

class ReactSparkCogWheel extends Component {
    componentDidMount() {
        this.selectInput = new SparkToolbar(this.selectInputMount);
    }

    render() {
        return (
            <div
                className="spark-toolbar spark-toolbar--icon"
                ref={node => (this.selectInputMount = node)}
                role="menubar"
                tabIndex="0"
            >
                <div className="spark-toolbar__container--visible">
                    <div
                        className="spark-toolbar__item theme-actions-cog-wheel"
                        label="Settings"
                        aria-label="Settings"
                        data-priority="3"
                        data-order="1"
                        role="menuitem"
                        tabIndex="-1"
                    >
                        <div className="spark-toolbar__item--content">{this.props.dropdownOptions}</div>
                        <div className="spark-icon-cog spark-toolbar__item-helper"></div>
                    </div>
                    <div className="spark-toolbar__show-more" tabIndex="-1">
                        <i className="spark-icon-menu-ellipsis-vertical"></i>
                    </div>
                    <div className="spark-toolbar__container--hidden" style={{ width: 0 }}></div>
                </div>
            </div>
        );
    }
}

ReactSparkCogWheel.propTypes = {
    label: PropTypes.string,
    values: PropTypes.array,
    defaultValue: PropTypes.string,
    onChange: PropTypes.func,
    isDisabled: PropTypes.bool
};

ReactSparkCogWheel.defaultProps = {
    isDisabled: false
};

export default ReactSparkCogWheel;



// WEBPACK FOOTER //
// ./src/components/widgets/ReactSparkCogWheel.js